export default __webpack_public_path__ + "static/media/discover-img-merge.a87d7a58.svg";